import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';
import { CommonService } from '@appShared/services/common.service';
import { AppFacade } from '@appShared/services/app.facade';
import { ShareholderFacade } from './shareholder.facade';
import { ToastrType } from '@appShared/services/toastr.service';
import { AdminService } from './admin.service';

@Injectable({ providedIn: 'root' })
export class ShareholderListGuardService implements CanActivate {
  constructor(
    private _adminService: AdminService,
    private _commonService: CommonService,
    private _shareholderFacade: ShareholderFacade,
    private _appFacade: AppFacade,
    private _router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

    return combineLatest([
      this._appFacade.userProfile$,
      this._appFacade.hasVerifiedSSN$,
      this._appFacade.areShareholdersAccessible$,
      this._appFacade.isAdminOnlyMode$
    ]).pipe(
      take(1),
      switchMap(([userProfile,
        hasVerifiedSSN,
        areShareholdersAccessible,
        isAdminOnlyMode]) => {

        if (!(userProfile?.objectId)) {
          const returnUrl = this._commonService.getResolvedUrl(route);
          this._commonService.navigateToLogin(returnUrl);
          return of(false);
        } else if (!areShareholdersAccessible) {

          if (!isAdminOnlyMode) {
            if (userProfile?.hasSubordinates && !hasVerifiedSSN) {
              // hasSubordinates have to verify SSN first
              this._router.navigate(['']);
              return of(false);
            }

            // this._commonService.messageUser(
            //  'Not Authorized to view this page',
            //  'Stock Plan Administration',
            //  ToastrType.error
            // );
            this._router.navigate(['']);
            return of(false);
          } else {
            // site offline - redirect home
            this._router.navigate(['']);
            return of(false);
          }
        }

        /* we were "prefetching" (commented below), but need
         * the page to "refresh" if admin goes "home" and back to "Admin"
         * ...so don't pull from _shareholderFacade.shareholders$ (state) */
        return this._adminService
          .getShareholders()
          .pipe(
            tap(shareholders =>
              this._shareholderFacade.setShareholders(shareholders)
            ),
            filter(data => !!data), // filter till has data
            take(1), // now that is has filtered data - take 1
            switchMap(() => of(true)),
            catchError(() => of(false))
          );

        /* removing the "state" set here since we need a "refresh" if they
         * go to Home and then back to Admin */
        // prefetch Observable<Shareholder[]>
        // return this._shareholderFacade.shareholders$.pipe(
        //  tap(shareholders =>
        //    this._shareholderFacade.prefetchShareholders(shareholders)
        //  ),
        //  filter(data => !!data), // filter till has data
        //  take(1), // now that is has filtered data - take 1
        //  switchMap(() => of(true)),
        //  catchError(() => of(false))
        // );
      }),
      catchError(() => of(false))
    );
  }
}
